import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { LocalStorageService } from 'src/app/core/services/localStorage/localStorage.service';

@Injectable({
  providedIn: 'root'
})
export class MessagingService {
  currentMessage = new BehaviorSubject<any>(null);
  private tokenSubscription: any;
  user:any;
  constructor(private angularFireMessaging: AngularFireMessaging, private http: HttpClient, private _lc: LocalStorageService) {}

  async requestPermission(): Promise<void> {
    try {
      // First check if notifications are supported
      if (!('Notification' in window)) {
        console.error('This browser does not support notifications.');
        return;
      }

      // Check current permission
      if (Notification.permission === 'denied') {
        console.error('Notification permission was denied by user.');
        alert('Please enable notifications in your browser settings.');
        return;
      }

      // Request permission if not already granted
      if (Notification.permission !== 'granted') {
        const permission = await Notification.requestPermission();
        if (permission !== 'granted') {
          console.error('User denied notification permission.');
          return;
        }
      }

      // Now try to get the token
      this.tokenSubscription = this.angularFireMessaging.requestToken
        .pipe(
          tap(token => {
            if (token) {
              console.log('✅ FCM Token received:', token);
              this.saveToken(token);
            } else {
              console.warn('No FCM token received');
            }
          })
        )
        .subscribe(
          (token) => {
            console.log('Token subscription successful');
          },
          (error) => {
            console.error('❌ Error getting token:', error);
            this.handleTokenError(error);
          }
        );

    } catch (error) {
      console.error('❌ Error in requestPermission:', error);
    }
  }

  receiveMessages() {
    this.angularFireMessaging.messages.subscribe(
      (payload: any) => {
        console.log('📬 New message received:', payload);
        this.currentMessage.next(payload);
        this.showNotification(payload);
      },
      (error) => {
        console.error('Error receiving message:', error);
      }
    );
  }

  private handleTokenError(error: any) {
    if (error.code === 'messaging/permission-blocked') {
      alert('Notifications are blocked. Please enable them in browser settings.');
    } else if (error.code === 'messaging/registration-token-not-subscribed-to-fcm-topic') {
      console.error('Not subscribed to FCM topic');
    } else if (error.message?.includes('push service error')) {
      console.error('Push service error - check service worker configuration');
      // alert('Push notification service error. Please try:\n1. Clear browser cache\n2. Reload the page\n3. Make sure you\'re using HTTPS or localhost');
    } else {
      console.error('Unknown error:', error);
    }
  }

  private showNotification(payload: any) {
    if (!payload.notification) return;
    
    const notificationTitle = payload.notification.title || 'New Notification';
    const notificationOptions = {
      body: payload.notification.body || '',
      icon: payload.notification.icon || '/assets/icon.png',
      badge: '/assets/badge.png',
      data: payload.data,
      requireInteraction: false,
      tag: 'notification-' + Date.now()
    };

    if (Notification.permission === 'granted') {
      new Notification(notificationTitle, notificationOptions);
    }
  }

  private saveToken(token: string | null) {
    console.log('💾 Token to save:', token);
    this.user = this._lc.getUser();
    let payload = { 
        "agentId": this.user?.id,
        "fcmToken":token,
        "agentRole": this.user?.roles?.[0]?.name,
        };
    // TODO: Send to your backend
    this.http.post('https://waba.crizac.com/api/v1/agents/register-fcm-token', payload ).subscribe();
  }

  ngOnDestroy() {
    if (this.tokenSubscription) {
      this.tokenSubscription.unsubscribe();
    }
  }
}